import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { ConditionNodeData } from '../../types/nodes';
import N8NStyleNode from './N8NStyleNode';

const ModernConditionNode = memo(({ data, selected }: NodeProps<ConditionNodeData>) => {
  const getIcon = () => {
    const icons: Record<string, string> = {
      'contains': '🔍',
      'equals': '🟰',
      'starts_with': '▶️',
      'ends_with': '⏸️',
      'regex': '🔤',
      'time_based': '🕐',
      'user_attribute': '🎯',
      'is_group': '👥',
      'is_group_admin': '🛡️',
      'group_size': '📊',
    };
    return icons[data.conditionType] || '🔀';
  };

  const getLabel = () => {
    const labels: Record<string, string> = {
      'contains': 'Contiene',
      'equals': 'Uguale a',
      'starts_with': 'Inizia con',
      'ends_with': 'Finisce con',
      'regex': 'Regex',
      'time_based': 'Basato su Orario',
      'user_attribute': 'Attributo Utente',
      'is_group': 'È un Gruppo',
      'is_group_admin': 'È Admin',
      'group_size': 'Dimensione Gruppo',
    };
    return labels[data.conditionType] || data.label;
  };

  const getSubtitle = () => {
    const config = data.config || {};
    if (config.value) return `"${config.value}"`;
    if ((data as any).value) return `"${(data as any).value}"`;
    if ((data as any).description) return (data as any).description;
    return 'Condizione';
  };

  return (
    <N8NStyleNode
      selected={selected}
      icon={getIcon()}
      label={getLabel()}
      subtitle={getSubtitle()}
      color="#f59e0b"
      handles={{
        target: true,
        sourceHandles: [
          { id: 'true', label: 'true' },
          { id: 'false', label: 'false' }
        ]
      }}
    />
  );
});

ModernConditionNode.displayName = 'ModernConditionNode';

export default ModernConditionNode;
